import React, { ReactNode, FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { ReactComponent as CircleIcon } from '../../../icons/circle.svg';

import StatusText, { StatusTextProps } from '../StatusText';

export interface PendingStatusTextProps extends Omit<StatusTextProps, 'Icon'> {
  /** Content of the status. */
  children: ReactNode;
}

const PendingStatusText: FC<PendingStatusTextProps> = (props) => {
  const theme = useContext(ThemeContext);

  return (
    <StatusText
      {...props}
      Icon={CircleIcon}
      iconColor={theme.colors.gray13}
    />
  );
};

export default PendingStatusText;
